'use client';

import { getFormattedWhatsappMessage } from '@/lib/whatsapp';
import { Product } from '@/payload-types';
import { Button } from '@/ui/shadcn/button';
import { useModal } from '@/ui/context/ModalContext';
import { X } from 'lucide-react';
import React, { useEffect, useState } from 'react';

const WhatsappModal = ({ product }: { product: Product | null }) => {
    const [message, setMessage] = useState('');
    const { closeModal, whatsappData } = useModal();
    const phoneNumber = whatsappData?.chatNumber ? whatsappData.chatNumber.replace(/^\+/, '') : '221770975523';

    useEffect(() => {
        const fetchMessage = async () => {
            const message = await getFormattedWhatsappMessage({ product });
            setMessage(message);
        }
        fetchMessage();
    }, [product]);

    return (
        <div className="whatsapp-modal">
            <button className="absolute top-6 right-6 cursor-pointer" onClick={closeModal}>
                <X className="size-6" />
            </button>
            <h2 className="text-3xl font-alt text-center font-regular mb-4 text-dark">
                Contactez-nous sur WhatsApp
            </h2>
            <p className="w-full mb-8 text-center">
                Vous allez être redirigé vers WhatsApp pour discuter avec notre équipe.
            </p>
            <a href={`https://wa.me/${phoneNumber}?text=${message}`} target="_blank">
                <Button variant="default" size="xl" className="w-full">
                    Nous contacter
                </Button>
            </a>
        </div>
    );
};

export default WhatsappModal;
